enum Department {
  Media = 'media',
  Technology = 'technology'
}

export function stringToDepartment(str: string): Department {
  switch (str) {
    case 'media':
      return Department.Media;
    case 'technology':
      return Department.Technology;
    default:
      throw new Error(`string ${str} is not a valid Department`);
  }
}

export default Department;
